import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState } from '@store/partners-registration/PartnersRegistrationState';



export const partnersRegistrationSlice = createSlice({
	name: 'partnersRegistration',
	initialState,
	reducers: {
		setShowInvalids: (state, action: PayloadAction<boolean>) => {
			state.showInvalids = action.payload
		},
		setContactPerson: (state, action: PayloadAction<string | null>) => {
			state.contactPerson = action.payload;
		},
		setClientName: (state, action: PayloadAction<string | null>) => {
			state.clientName = action.payload;
		},
		setEmail: (state, action: PayloadAction<string | null>) => {
			state.email = action.payload;
		},
		setPhoneNumber: (state, action: PayloadAction<string | null>) => {
			state.phoneNumber = action.payload;
		},
		setStreet: (state, action: PayloadAction<string | null>) => {
			state.street = action.payload;
		},
		setCity: (state, action: PayloadAction<string | null>) => {
			state.city = action.payload;
		},
		setPostalCode: (state, action: PayloadAction<string | null>) => {
			state.postalCode = action.payload;
		},
		setInvoiceStreet: (state, action: PayloadAction<string | null>) => {
			state.invoiceStreet = action.payload;
		},
		setInvoiceCity: (state, action: PayloadAction<string | null>) => {
			state.invoiceCity = action.payload;
		},
		setInvoicePostalCode: (state, action: PayloadAction<string | null>) => {
			state.invoicePostalCode = action.payload;
		},
		setRegistrationNumber: (state, action: PayloadAction<string | null>) => {
			state.registrationNumber = action.payload;
		},
		setVatnumber: (state, action: PayloadAction<string | null>) => {
			state.vatnumber = action.payload;
		},
		setSalesMan: (state, action: PayloadAction<string | null>) => {
			state.salesMan = action.payload;
		},
		setMessage: (state, action: PayloadAction<string | null>) => {
			state.message = action.payload;
		},
		resetStore: (_) => initialState,
	},
});

export default partnersRegistrationSlice.reducer;



export const {
	setShowInvalids,
	setContactPerson,
	setClientName,
	setEmail,
	setPhoneNumber,
	setStreet,
	setCity,
	setPostalCode,
	setInvoiceStreet,
	setInvoiceCity,
	setInvoicePostalCode,
	setRegistrationNumber,
	setVatnumber,
	setSalesMan,
	setMessage,
	resetStore } = partnersRegistrationSlice.actions;